/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DisplayDesignProjectTile_designProject = {
    readonly serviceId: string | null;
    readonly addressDisplayString: string | null;
    readonly name: string | null;
    readonly rootId: number | null;
    readonly status: string | null;
    readonly coverPhoto: string | null;
    readonly url: string | null;
    readonly " $refType": "DisplayDesignProjectTile_designProject";
};
export type DisplayDesignProjectTile_designProject$data = DisplayDesignProjectTile_designProject;
export type DisplayDesignProjectTile_designProject$key = {
    readonly " $data"?: DisplayDesignProjectTile_designProject$data;
    readonly " $fragmentRefs": FragmentRefs<"DisplayDesignProjectTile_designProject">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "DisplayDesignProjectTile_designProject",
  "type": "DesignProjectCover",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "addressDisplayString",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "rootId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "coverPhoto",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '0d439a5937768316b8e1c75451afb3da';
export default node;
